import {useEffect} from 'react';

import {isUhcEnabled} from 'libs/rollout';

import {managerNewsletterSubscription} from './managerNewsletterSubscription';
import {useProcessEmail} from './useProcessEmail';
import {useSubscriptionInfo} from './useSubscriptionInfo';

/**
 * hook for set subscription email
 */
export const useSetSubscriptionEmail = (
    setVisibility: (data: boolean) => void,
    setCheckbox: (data: boolean) => void,
    isSubscriptionEnabledForLocation: boolean,
) => {
    const subscriptionEmail = useProcessEmail();
    const {data: subscriptionStatus, isInitialLoading: isLoading} = useSubscriptionInfo(
        subscriptionEmail,
        isUhcEnabled(),
    );

    useEffect(() => {
        if (isLoading) return;
        managerNewsletterSubscription.setSubscriptionEmail(subscriptionEmail);
        managerNewsletterSubscription.setSubscriptionStatus(subscriptionStatus);
        managerNewsletterSubscription.setEnabledForLocation(isSubscriptionEnabledForLocation);
        const data = managerNewsletterSubscription.getCheckboxData();
        setVisibility(data.isVisible);
        setCheckbox(data.isChecked);
    }, [
        isLoading,
        isSubscriptionEnabledForLocation,
        subscriptionStatus,
        subscriptionEmail,
        setVisibility,
        setCheckbox,
    ]);
};
